@if (state() !== 'unlocked') {
	<div class="native-lock" role="dialog" aria-modal="true" aria-labelledby="nativeLockTitle">
		<div class="native-lock__content">
			<img class="native-lock__logo" src="assets/img/logo.png" width="160" height="160" alt="" />
			<h1 class="native-lock__title" id="nativeLockTitle">SilGov bloqueado</h1>

			@if (state() === 'locked') {
				<p class="native-lock__text">Confirme sua identidade para continuar.</p>
				<div class="spinner-border text-primary mt-2" role="status">
					<span class="visually-hidden">Aguardando a biometria</span>
				</div>
			} @else {
				<p class="native-lock__text">Não foi possível confirmar sua identidade.</p>
				<div class="native-lock__actions">
					<button type="button" class="btn btn-primary w-100" [disabled]="retrying()" (click)="retry()">Tentar novamente</button>
					<button type="button" class="btn btn-link w-100" [disabled]="retrying()" (click)="signInWithPassword()">Entrar com senha</button>
				</div>
			}
		</div>
	</div>
}
